/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateSeen.defs'
export { main as default } from './updateSeen.defs'
